import React from "react";
import ViewportFullView from "components/ViewportContainer/Full/Full";

export function FullView(props) {
  const { viewports, renderViewport } = props;

  const isViewportEnabled = (index) => {
    return viewports.length - 1 === index;
  };

  const renderViewports = () => {
    if (viewports.length === 0) return;
    return (
        viewports.map((viewport, index) => (
          <ViewportFullView key={index}>
            {renderViewport(viewport, isViewportEnabled(index))}
          </ViewportFullView>
        ))
      );
  };

  return (
      renderViewports()
  )
}